
import React from 'react';
import Store from '../../redux/store';
import '../../resources/css/notice-page.css';
import i18n from '../../i18n';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from '../../messenger/module';
import _ from 'lodash';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import { Button } from '@material-ui/core';
import { getCacheField } from '../../tools/get-cache-field';
import { Menu, TableStatus } from '../../constants/type.constant';
import { DefaultRequest } from '../../requests/default.request';
import { createHashHistory } from 'history';
import MenuItem from './home-menu-item.componemt';

class LiteFooterBar extends React.Component<Props, State>{
    public messengerModule: MessengerModule;
    public scrollHomeViewTimeOut!: NodeJS.Timeout;
    public scrollCount = 0;
    constructor(props: Props) {
        super(props);
        this.state = {
            isTouchMove: false,
            touchStartY: 0,
            touchEndY: 0,
            isShowHomeOrder: false,
            selectedMenuId: 0,
            // 人数
            person: [{
                type: 'NORMAL',
                num: 0,
            }, {
                type: 'CHILD',
                num: 0,
            }],
            // 当前桌台状态
            resultTableStatus: [],
            isLoading: false,
            // 是否开启审核功能
            isApproved: true,
            // 是否开启自主点餐模式
            autonomous: {
                status: false
            },
            // 用数组形式存储人数
            peopleArr: [],
            // 额外费用ID
            menuId: 0,
        }
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
    }

    // *********************
    // 生命周期
    // *********************

    public async componentDidMount() {
        // 没有桌台id，跳回启动页
        // 获取桌台状态
        let resultTableStatusPerson = getCacheField('orderTab.person')
        // 有订单id && 菜单id不为空 跳到首页
        if (getCacheField('orderTab.orderId') && getCacheField('orderTab.menuList.main_group_id') && resultTableStatusPerson) {
            createHashHistory().push({ pathname: '/LiteHome' });
        }
        // 获取菜单
        this.getSetting();

    }

    public componentWillUnmount() {
        document.removeEventListener('scroll', this.scrollHomeView);
        this.setState = (state, callback) => { return; };
    }
    public scrollHomeView = () => {
        clearTimeout(this.scrollHomeViewTimeOut)
        let menuTop = document.getElementById('homeMainTop');
        this.scrollCount += 1;
        // 性能优化 ,限制100ms内只执行一遍
        this.scrollHomeViewTimeOut = setTimeout(() => {
            console.log(menuTop?.scrollTop, 'scrollTop ')
            if (menuTop ? menuTop.scrollTop === 0 : 0) {
                if (this.state.isTouchMove) {
                    this.setState({ isTouchMove: false });
                }
            }
            this.scrollCount = 0;
        }, 100);
    }
    public async getSetting() {
        try {
            let settingInfo = await DefaultRequest.getSettingInfo();
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'settingInfo',
                value: settingInfo
            });
            // 自主点餐
            const AUTONOMOUS = settingInfo.find((target: any) => {
                return target.name === 'rule-autonomous-meal'
            })
            // 是否开启审核功能
            const ISAPPROVED = settingInfo.find((target: any) => {
                return target.name === 'open-table-audit'
            })
            // 额外费用id
            const MENUID = settingInfo.find((target: any) => {
                return target.name === 'package-fee'
            })
            MENUID && this.setState({ menuId: MENUID.value.menu_id })
            ISAPPROVED && this.setState({ isApproved: ISAPPROVED.value.enable })
            AUTONOMOUS && this.setState({ autonomous: AUTONOMOUS.value })

        } catch (error) {
            console.log(error);
        }
    }

    // *********************
    // 方法区
    // *********************

    // *********************
    // 视图区
    // *********************
    render() {
        const { isShowHomeOrder } = this.state;
        const { specialMenu, normalMenu, disabledOrderBtn } = this.props;
        return (
            <React.Fragment>

                {/* 开台信息页面 */}
                {
                    isShowHomeOrder ?
                        <React.Fragment>
                            <div className="home-order">
                                <div className="home-order-topBar">
                                    <div className="goBack">
                                        < ArrowBackIosOutlinedIcon
                                            onClick={() => {
                                                this.setState({
                                                    isShowHomeOrder: false
                                                })
                                            }} />
                                    </div>
                                    <div style={{ flex: 1 }}>{i18n.t('auto_open_page_open_table')}</div>
                                </div>
                                {/* 选择菜单 */}
                                <div className="selectedMenu">
                                    <div className="homeTitle">{i18n.t('auto_open_page_text_menu')}</div>
                                    <div className="selectedMenu-main">
                                        {/* 普通菜菜单 */}
                                        {
                                            _.has(normalMenu, 'main_group_name') &&
                                            <MenuItem
                                                item={normalMenu}
                                                selectedMenuId={this.state.selectedMenuId}
                                                updateState={(val) => {
                                                    this.setState(val)
                                                }}
                                            />
                                        }
                                        {/* 特殊菜菜单 */}
                                        {
                                            specialMenu.map((item, index) => {
                                                return (
                                                    <MenuItem
                                                        key={index}
                                                        item={item}
                                                        selectedMenuId={this.state.selectedMenuId}
                                                        updateState={(val) => {
                                                            this.setState(val)
                                                        }}
                                                    />
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="home-page-bottom-lite">
                                {/* <div className="table-name">
                                    <div className="freebrrak-icon"></div>
                                    <div>{getCacheField('tableName')}</div>
                                </div> */}
                                <div className="order-now-lite">
                                    <Button
                                        style={{ display: 'flex', flex: 1 }}
                                        disabled={disabledOrderBtn}
                                        onClick={() => {
                                            this.setState({
                                                isLoading: true
                                            }, () => {
                                                const { specialMenu, normalMenu } = this.props;
                                                const { selectedMenuId } = this.state;
                                                const MENU_ITEM = [...specialMenu, normalMenu]
                                                const findItem = MENU_ITEM.find((item) => {
                                                    return selectedMenuId === item.main_group_id;
                                                })
                                                if (findItem) {
                                                    // 选中的菜品
                                                    let select_menu = findItem;
                                                    const OORDER_TAB = Store.getState().orderTab
                                                    // 订单信息
                                                    Store.dispatch({
                                                        type: 'SET_CACHING',
                                                        path: 'orderTab',
                                                        value: {
                                                            ...OORDER_TAB,
                                                            menuList: {
                                                                // id
                                                                main_group_id: select_menu.main_group_id,
                                                                // name
                                                                main_group_name: select_menu.main_group_name,
                                                            },
                                                        },
                                                    })
                                                    createHashHistory().push({ pathname: '/LiteMain' });
                                                }
                                            })
                                        }}
                                    >
                                        <div className="Jumplink-bottom">
                                            <div>{i18n.t('auto_open_page_text_order_now')}</div>
                                        </div>

                                    </Button>
                                </div>
                            </div>
                        </React.Fragment>
                        :
                        <FooterArea
                            disabled={disabledOrderBtn}
                            updateState={() => {
                                this.setState({
                                    isShowHomeOrder: true
                                })
                            }}
                        />
                }




            </React.Fragment >
        )
    }

}
export default withSnackbar(LiteFooterBar);

// **********
// TYPE
// **********

type Props = {
    // 普通菜单数据
    normalMenu: Menu;
    // 备选菜单数据
    specialMenu: Array<Menu>;
    // 禁用《立即点餐》按钮
    disabledOrderBtn: boolean;
} & WithSnackbarProps

type State = {

    isTouchMove: boolean;
    // 上下滑动数值
    touchStartY: number;
    touchEndY: number;
    // 是否显示开台编辑页面
    isShowHomeOrder: boolean;
    // 选择的菜单id
    selectedMenuId: number;
    // 人数
    person: Array<{
        // 类型
        type: 'NORMAL' | 'CHILD'
        // 人数
        num: number
    }>;
    // 当前桌台状态
    resultTableStatus: TableStatus[];
    isLoading: boolean;
    // 是否开启审核功能
    isApproved: boolean;
    // 自主点餐是否开启
    autonomous: {
        status: boolean
    };
    peopleArr: Array<string>;
    // 额外费用ID
    menuId: number;
}

/**
 * Home页面底部点餐跳转按钮
 */
export function FooterArea(props: {
    updateState: () => void;
    disabled?: boolean;
}) {
    return (

        <div className="home-page-bottom-lite">
            {/* <div className="table-name">
                <div className="freebrrak-icon"></div>
                <div>{getCacheField('tableName')}</div>
            </div> */}
            <div className="order-now-lite">
                <Button
                    style={{ display: 'flex', flex: 1 }}
                    onClick={() => {
                        props.updateState();
                    }}
                    disabled={props.disabled}
                >
                    <div className="Jumplink-bottom">
                        <div>{i18n.t('auto_open_page_text_order_now')}</div>
                    </div>

                </Button>
            </div>
        </div>
    )
}